import axios from "axios";
const jsonConfig = require("../../Config.json");

const emailVerificationResponse = async (payLoad) => {
    let allResponse = {}
    try {
        const emailResponse = await axios.post(
            jsonConfig.apiUrl + "EmailVerification", payLoad,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );

        allResponse = emailResponse;

        return Promise.resolve(allResponse)
    }
    catch (error) {
        console.log("errrrrr", error);
        return Promise.reject(error);
    }
}

export default emailVerificationResponse;